import { apiFetcher } from '../api-fetcher';

type IssuableCouponsResponse = {
  data: Coupon[];
}

export type IssuableCouponsParams = {
  pid: number;
  paymentAmount: number;
  categoryId: string;
  brandId?: number;
  sellerUid: number;
  overseas: boolean; // 해외상품 여부
  productInspectionStatus?: 'OPT_IN' | 'OPT_OUT' | 'NON_TARGET' | 'INSPECTED';
};

interface DiscountInfo {
  description: string; // 결제 금액에 따라 계산한 할인 정보
  discountRate: number; // 쿠폰 적용 할인률
  discountAmount: number; // 쿠폰 적용 할인 금액
}

export interface Coupon {
  couponId: number; // 쿠폰 ID
  maxIssueCountPerUser: number; // 쿠폰 1인당 최대 발급 count
  discountInfo: DiscountInfo; // 할인 정보
  downloadable: boolean; // 쿠폰 다운로드 가능 여부
  viewSubTitle: string; // 노출 서브 타이틀
  viewPreCondition: string; // 노출 제한 조건(컨텐츠)
  viewTimeLeft: string; // 노출 쿠폰 만료 남은 시간
  viewTitle: string; // 노출 메인 타이틀
}

export const getIssuableCoupons = async (params: IssuableCouponsParams) => {
  return apiFetcher.get<IssuableCouponsResponse>(`/api/coupon/v1/coupons/issuable`, params);
};
